import customAxios from "../../customAxios";
import { ADD_SERVICE_TO_DRIVER } from "../../routes";

const addServiceToDriver = async ({
  serviceId,
  driverId,
}: {
  serviceId: string;
  driverId: string;
}) => {
  const body = {
    driver:driverId,
  };
  try {
    return (
      await customAxios.put(ADD_SERVICE_TO_DRIVER + "/" + serviceId, body)
    ).data;
  } catch (error: unknown) {
    console.error({ APPROVE_DRIVER: error });
    return false;
  }
};

export default addServiceToDriver;
